var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"slide-timeline"},[_c('BlockTracks')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }